import { removeEmptyValues } from '@ianesthesie-kit/core';
import { isEmpty, toKebabQuery } from '@/util';

/**
 * Module-internal query-string helper shared by {@link BillingService} and
 * {@link BillingLineService}: drops empty/nullish entries, kebab-cases the keys the way the
 * platform expects (`billingDoctorId` → `billing-doctor-id`) and returns `''` — not a bare
 * `?` — for an empty param object so it can always be appended to a URL. Deliberately not
 * re-exported from the module barrel: it is a service-layer detail, not part of the
 * billing module's public surface.
 */
export const stringifyParams = (params?: object): string => {
  // Strip empty values BEFORE the emptiness check: `{ doctorId: undefined }` must yield
  // `''` like `{}` does, not a bare `?`.
  const cleaned = params
    ? removeEmptyValues(params as Record<string, unknown>)
    : undefined;
  if (isEmpty(cleaned)) {
    return '';
  }
  return toKebabQuery(cleaned as Record<string, unknown>);
};
